export default {
  key: 'floahverfi',
  basepath: '/lodir/floahverfid',
  image: {
    src: require('images/lodir/floahverfid/dji-0008.jpg'),
    width: 5272,
    height: 2962,
  },
  afangar: [require('./afangi-a.js').default, require('./afangi-b.js').default],
}
